import React, { useState, useEffect } from "react";
import { Form, Input, Select, Checkbox } from "antd";

import {
  currenciesSelect as currencies,
  transformToSelect,
  paymentForms as paymentFormsDict,
  paymentMethods as paymentMethodsDict,
} from "../../constants/transport";

import validations from "../../utils/validations";
import FloatingField from "../common/FloatingField";

const paymentForms = transformToSelect(paymentFormsDict);
const paymentMethods = transformToSelect(paymentMethodsDict);

const Price = ({ form, order, duplicate, watchedValues = {} }) => {
  const [showPriceFields, setShowPriceFields] = useState(true);

  const togglePriceMode = (_mode) => {
    if (!_mode) {
      console.log("set null");
      form.setFieldsValue({
        price: null,
        currency: null,
        nds: false,
      });
    }

    console.log(form.getFieldsValue());

    setShowPriceFields(_mode);
  };

  useEffect(() => {
    console.log("price", order);
    if (order && !order.price) {
      setShowPriceFields(false);
    }
  }, [order]);
  useEffect(() => {
    console.log("duplicate", duplicate);
    if (duplicate && !duplicate.price) {
      setShowPriceFields(false);
    }
  }, [duplicate]);
  return (
    <>
      <div className="order-form__section__title">
        <span className="order-form__section__title__text">
          Ставка и оплата
        </span>
      </div>
      <div
        className="order-form__section__row select-price-mode"
        style={{ marginBottom: "20px", marginTop: "15px", width: "250px" }}
      >
        <div className="search__switcher">
          <div className="search__switcher__options">
            <div
              style={{ width: "120px" }}
              className={`search__switcher__options__item ${showPriceFields ? "active" : ""}`}
              onClick={() => togglePriceMode(true)}
            >
              Ставка
            </div>
            <div
              style={{ width: "80px" }}
              className={`search__switcher__options__item ${!showPriceFields ? "active" : ""}`}
              onClick={() => togglePriceMode(false)}
            >
              Торг
            </div>
          </div>
        </div>
      </div>
      {!showPriceFields && (
        <div className="order-form__section__row order-form__section__row--double">
          <Form.Item label="Ваша стоимость за перевозку">
            <Input
              placeholder="Запрос ставки"
              type="tel"
              size="large"
              className="height-44"
              disabled
            />
          </Form.Item>
          <div style={{ marginTop: "5px" }}>
            <Form.Item name="nds" valuePropName="checked" label=" ">
              <Checkbox>с НДС</Checkbox>
            </Form.Item>
          </div>
        </div>
      )}
      {showPriceFields && (
        <div className="transport-search-form__row transport-search-form__row--stack-mobile">
          <div
            className="transport-search-form__row transport-search-form__row--child-full"
            style={{ flexDirection: "column" }}
          >
            <Form.Item rules={[validations.required]} name="price" label=" ">
              <FloatingField label="Цена*" active={watchedValues.price}>
                <Input
                  placeholder=""
                  type="number"
                  size="large"
                  className="height-44"
                />
              </FloatingField>
            </Form.Item>
          </div>
          <div className="transport-search-form__row transport-search-form__row--child-full special-case">
            <Form.Item
              rules={[validations.required]}
              name="currency"
              label="Ваша стоимость за перевозку"
            >
              <FloatingField label="Валюта*" active={watchedValues.currency}>
                <Select
                  placeholder=""
                  size="large"
                  style={{ width: "100%" }}
                  optionLabelProp="customLabel"
                >
                  {currencies.map((currency) => (
                    <Select.Option
                      key={currency.value}
                      value={currency.value}
                      customLabel={
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <img
                            src={`/img/${currency.icon}.png`}
                            alt={currency.label}
                            style={{ width: "20px", marginRight: "8px" }}
                          />
                          {currency.label}
                        </div>
                      }
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <img
                          src={`/img/${currency.icon}.png`}
                          alt={currency.label}
                          style={{ width: "20px", marginRight: "8px" }}
                        />
                        {currency.label}
                      </div>
                    </Select.Option>
                  ))}
                </Select>
              </FloatingField>
            </Form.Item>
            <Form.Item name="nds" valuePropName="checked" label=" ">
              <Checkbox>с НДС</Checkbox>
            </Form.Item>
          </div>
        </div>
      )}
      <div className="transport-search-form__row transport-search-form__row--stack-mobile">
        <div
          className="transport-search-form__row transport-search-form__row--child-full"
          style={{ flexDirection: "column" }}
        >
          <Form.Item name="payment_form" label="Условие оплаты">
            <FloatingField label="Условие оплаты" active={watchedValues.payment_form}>
              <Select
                placeholder=""
                options={paymentForms}
                size="large"
              />
            </FloatingField>
          </Form.Item>
        </div>
        <div
          className="transport-search-form__row transport-search-form__row--child-full"
          style={{ flexDirection: "column" }}
        >
          <Form.Item name="payment_method" label="Форма оплаты">
            <FloatingField label="Способ оплаты" active={watchedValues.payment_method}>
              <Select
                placeholder=""
                options={paymentMethods}
                size="large"
              />
            </FloatingField>
          </Form.Item>
        </div>
      </div>
    </>
  );
};

export default Price;
